import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const ThemeCtx = createContext(null);
const LS_KEY = "theme";

// Halaman yang SELALU tampil mode terang (night mode tidak berlaku di sini).
const LIGHT_ONLY_PATHS = ["/login", "/papan-harga"];

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem(LS_KEY) || "light");

  useEffect(() => {
    localStorage.setItem(LS_KEY, theme);
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <ThemeCtx.Provider value={{ theme, setTheme, toggleTheme, isDark: theme === "dark" }}>
      {children}
    </ThemeCtx.Provider>
  );
}

// Menerapkan kelas .dark ke <html> dengan menghormati pengecualian per-rute.
// WAJIB dirender di dalam Router (butuh useLocation).
export function ThemeApplier() {
  const { theme } = useTheme();
  const { pathname } = useLocation();

  useEffect(() => {
    const root = document.documentElement;
    const lightOnly = LIGHT_ONLY_PATHS.some((p) => pathname.startsWith(p));
    const dark = theme === "dark" && !lightOnly;
    root.classList.toggle("dark", dark);
    root.style.colorScheme = dark ? "dark" : "light";
  }, [theme, pathname]);

  return null;
}

export const useTheme = () => useContext(ThemeCtx);
